// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1zZ7B","rootSuccess":"CompleteLink_rootSuccess__2ndM6","rootFailure":"CompleteLink_rootFailure__36MJE","isDisabled":"CompleteLink_isDisabled__2IOGt"};